<template>
  <div>

    <ed-modal 
      :modal="showModal" 
      :isModal="false"
      :title="'EXAMES'+(funcionario ? ' - '+funcionario.nome : '')+(formData.consulta ? ' - CONSULTA '+formData.consulta.id_con : '')" 
      width="60%"
    >
    
    <div slot="modal-content">

      <ed-table
        :tableData="tableDataExame"
        :tableHead="tableHeadExame"
        :pagination="paginationExame"
        :response="response"
        :loadingTable="loadingTableExame"
        :onSearch="getExame"
        disableCheckAll
        disableInputSearch
        disabledConfigCell
      />
    </div>
  </ed-modal>
  
  <ed-alert
    class="mb-3"
    type="warning"
    description="Exibindo o histórico de consultas dos últimos 10 anos"
    title="Atenção"
  />

    <ed-table
      :tableData="tableData"
      :tableHead="tableHead"
      :pagination="pagination"
      :response="response"
      :loadingTable="loadingTable"
      disableCheckAll
      disableInputSearch
    />

  </div>
</template>

<script>

import Rest from 'common/rest'
import EdTable from 'common/table'
import EdModal from 'common/modal'
import EdAlert from 'common/alert'

export default {
    name: 'EmpresaCadastro',
    components:{EdModal,EdAlert,EdTable},
    mixins:[Rest],
    props:{
    funcionario:{
      type: Object,
      default: null
    },
    empresa:{
      type: Object,
      default: null
    },
    id_funcao:{
      type: Number,
      default: null
    },
  },
  watch:{
    funcionario(){
      this.getHistorico()
    },
    empresa(){
      this.getHistorico()
    },
    id_funcao(){
      this.getHistorico()
    },
  },

  data () {
    return{
      formData:{
        historico:null,
        consulta:null,
        exames:[],
      },
      pagination:{},
      paginationExame:{},
      response:{},
      tableData:[],
      tableDataExame:[],
      tableHeadExame:[
        {
          key: 'exame',
          sortable: true,
          show_rea:true,
          show_dem:true,
          show_alt:true,
          label: 'Exame',
        },
        {
          key: 'data',
          sortable: true,
          label: 'Data',
          width:'100px',
        },
        // {
        //   key: 'valor',
        //   sortable: true,
        //   label: 'Valor',
        //   width:'150px',
        // },
      ],
      tableHead:[
        {
          key: 'consulta',
          sortable: true,
          label: 'Consulta',
          width:'90px',
        },
        {
          key: 'data',
          sortable: true,
          label: 'Data',
          width:'100px',
        },
        {
          key: 'tipo_aso',
          sortable: true,
          label: 'Tipo',
          width:'200px',
        },
        {
          key: 'funcao',
          sortable: true,
          label: 'Função',
        },
      ],
      showModal:false,
      loadingTable:false,
      loadingTableExame:false,
    }
  },
  beforeDestroy(){
		this.tableData = [];
	},
  created(){
  },
  mounted(){
    this.getHistorico();
  },

  methods: {

    onShowExame(consulta){
      this.showModal = !this.showModal;
      this.formData.consulta = consulta;
      this.getExame();
    },

    getExame(_search,_page,_pagination){

      this.loadingTableExame = true;
      this.formData.exames = [];

      this.get('empresa/consulta/exame/'+this.formData.consulta.id_con,{search:_search,page:_page,pagination:_pagination}).then((result) =>{
        result = result[0]; 

        this.loadingTableExame = false;

        var data = [], tableData = [], pagination = {};

        if(result.status == 200){
            
          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              exame: data[i].exame.nome,
              data: (data[i].dt_cad ?this.toDate(data[i].dt_cad,true) : null),
              valor: data[i].valor,
              _data: data[i],
              buttons : []
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        this.tableDataExame = tableData;
        this.paginationExame = pagination;

      });
    },

    getHistorico(_search){

      if(!this.funcionario || !this.empresa || !this.funcionario.id)return;

      this.loadingTable = true;
      this.formData.historico = null;
      this.response = {};

      var 
      ontem = this.convertDate(this.addDate(-10,null,'y')),
      amanha = this.convertDate(this.addDate(30,null)),
      filter = {
        id_empresa: this.empresa.id,
        id_funcionario: this.funcionario.id,
        show_con_exa:1,
        created_at: [ontem,amanha]
      };

      this.get('empresa/consulta',{filter:filter}).then((result) =>{
        result = result[0];

        this.response = result;
        this.loadingTable = false;

        var data = [], tableData = [], pagination = {};

        if(result.status == 200){
            
          data = result.data.data;

          for (var i = 0; i < data.length; i++) {

            var item = {
              id: data[i].id,
              consulta: data[i].id_con,
              funcao: (data[i].funcao ? data[i].funcao.nome : null),
              tipo_aso: (data[i].tipo_aso ? data[i].tipo_aso.descricao : null),
              data: this.toDate(data[i].dt_cad,true),
              exames: '',
              _data: data[i],
              buttons : [
                {
                  color: 'primary',
                  icon : 'fa fa-search',
                  title: 'Ver Exames',
                  click : this.onShowExame

                },
              ]
            };

            tableData.push(item);
          }

          pagination = result.data;
        }

        this.tableData = tableData;
        this.pagination = pagination;
      });
    },

  }
}
</script>


// WEBPACK FOOTER //
// historico.vue?4c5251e3